import script from "./NavBase.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBase.vue?vue&type=script&setup=true&lang=js"

import "./NavBase.vue?vue&type=style&index=0&id=987bff92&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-987bff92"]])

export default __exports__